var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returned-value-box pt-3 pb-4",class:{ innerElement: _vm.innerElement }},[_c('div',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.text)),_c('b',[_c('span',{staticClass:"text-primary"},[_vm._v("£"+_vm._s(_vm.formatNumberOutput(_vm.value)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }